export default __webpack_public_path__ + "static/media/36I-114280_-20487_0.f7ec5ce1.jpg";